import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useTitle } from "../../hooks/useTitle";
import { confirmEmailVerification } from "../../services/ledgerService";

import "./auth.css";

// VerifyEmailPage handles the link from the verification email
// (/verify-email?token=…). No auth — the token is the credential.
//
// Confirmation is gated behind an explicit button click, NOT fired on mount:
// corporate mail scanners (Proofpoint, Safe Links, etc.) fetch and even render
// emailed links in a headless browser to detonate them, which auto-verified
// accounts when this page confirmed on load (docs/bot-signup-abuse.md). A
// scanner won't click, so a human gesture is required.
export function VerifyEmailPage() {
    useTitle("Verify your email");
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token") || "";
    const [status, setStatus] = useState(token ? "idle" : "error");

    const handleVerify = () => {
        if (!token) return;
        setStatus("loading");
        confirmEmailVerification({ token })
            .then(() => setStatus("success"))
            .catch(() => setStatus("error"));
    };

    return (
        <section className="mkt-auth">
            <div className="mkt-auth-mast">
                <div className="mkt-auth-mast-kicker">Email verification</div>
                <h1>
                    {status === "success" ? (
                        <>Email <em>verified.</em></>
                    ) : (
                        <>Verify your <em>email.</em></>
                    )}
                </h1>
                <p>
                    {status === "idle" && "Confirm your email address to finish setting up your account."}
                    {status === "loading" && "Verifying your email address…"}
                    {status === "success" && "Thanks — your email address is confirmed."}
                    {status === "error" && "This verification link is invalid or has expired."}
                </p>
            </div>

            <div className="mkt-auth-card">
                <div className="mkt-auth-form">
                    {(status === "idle" || status === "loading") && (
                        <button type="button" onClick={handleVerify} disabled={status === "loading"}>
                            {status === "loading" ? "Verifying…" : "Verify my email"}
                        </button>
                    )}
                    {status === "success" && (
                        <div className="mkt-auth-foot">
                            <a href="/games">Go to your games</a>
                        </div>
                    )}
                    {status === "error" && (
                        <div className="mkt-auth-foot">
                            Open your <a href="/profile">profile</a> to request a new link.
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
